(function (process,global,Buffer,__argument0,__argument1,__argument2,__argument3,__filename,__dirname){
(function() {
  'use strict'

  function noop() {}

  var Waypoint = window.Waypoint

  /* http://imakewebthings.com/waypoints/shortcuts/inview */
  function Inview(options) {
    this.options = Waypoint.Adapter.extend({}, Inview.defaults, options)
    this.axis = this.options.horizontal ? 'horizontal' : 'vertical'
    this.waypoints = []
    this.createWaypoints()
  }

  /* Private */
  Inview.prototype.createWaypoints = function() {
    var configs = {
      vertical: [{
        down: 'enter',
        up: 'exited',
        offset: '100%'
      }, {
        down: 'entered',
        up: 'exit',
        offset: 'bottom-in-view'
      }, {
        down: 'exit',
        up: 'entered',
        offset: 0
      }, {
        down: 'exited',
        up: 'enter',
        offset: function() {
          return -this.adapter.outerHeight()
        }
      }],
      horizontal: [{
        right: 'enter',
        left: 'exited',
        offset: '100%'
      }, {
        right: 'entered',
        left: 'exit',
        offset: 'right-in-view'
      }, {
        right: 'exit',
        left: 'entered',
        offset: 0
      }, {
        right: 'exited',
        left: 'enter',
        offset: function() {
          return -this.adapter.outerWidth()
        }
      }]
    }

    for (var i = 0, end = configs[this.axis].length; i < end; i++) {
      var config = configs[this.axis][i]
      this.createWaypoint(config)
    }
  }

  /* Private */
  Inview.prototype.createWaypoint = function(config) {
    var self = this
    this.waypoints.push(new Waypoint({
      element: this.options.element,
      context: this.options.context,
      handler: (function(config) {
        return function(direction) {
          self.options[config[direction]].call(this, direction)
        }
      }(config)),
      offset: config.offset,
      horizontal: this.options.horizontal
    }))
  }

  /* Public */
  Inview.prototype.destroy = function() {
    for (var i = 0, end = this.waypoints.length; i < end; i++) {
      this.waypoints[i].destroy()
    }
    this.waypoints = []
  }

  Inview.defaults = {
    enter: noop,
    entered: noop,
    exit: noop,
    exited: noop
  }

  Waypoint.Inview = Inview
}())
}).call(this,require('_process'),typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {},require("buffer").Buffer,arguments[3],arguments[4],arguments[5],arguments[6],"/Scripts\\Plugins\\inview.js","/Scripts\\Plugins")
//# sourceMappingURL=data:application/json;charset:utf-8;base64,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